"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICE_DISPLAY = exports.PRICE_FONT_TYPE = exports.PRICE_OPACITY = exports.PRICE_DECORATION = exports.PRICE_COLORS = exports.PRICE_SIZE = exports.PRICE_SEGMENT = void 0;
exports.PRICE_SEGMENT = {
    GP: 'gp',
    EMP: 'emp',
};
exports.PRICE_SIZE = {
    SMALL: "small",
    REGULAR: "regular",
    // TextInfo sizes
    TITLE1: 'title01',
    TITLE2: 'title02',
    TITLE3: 'title03',
    TITLE4: 'title04',
    TITLE45: 'title045',
    TITLE5: 'title05',
    TITLE6: 'title06',
    TITLE7: 'title07',
    DISPLAY1: 'display01',
    DISPLAY2: 'display02',
    DISPLAY3: 'display03',
    CAPTION1: 'caption01',
    CAPTION2: 'caption02',
    CAPTION3: 'caption03',
};
exports.PRICE_COLORS = {
    BLACK: "black",
    WHITE: "white",
    GREEN: "green",
    GREEN_LIGHT: "green-light",
    GREEN_DARK: "green-dark",
    COOL_GREY: "cool-grey",
    GREY_6: "grey6",
    GREY_5: "grey5",
    GREY_5B: "grey5b",
    GREY_4: "grey4",
    GREY_4A: "grey4a",
    GREY_3: "grey3",
    GREY_2: "grey2",
    GREY_1: "grey1",
    GREY_1A: "grey1a",
    GREY_A: "greya",
    GREY_0: "grey0",
    ORANGE: "orange",
    ORANGE_LIGHT: "orange-light",
    ORANGE_DARK: "orange-dark",
    EGG: "egg",
    BLUE: "blue",
    BLUE_A: "blue-a",
    BLUE_DARK: "dark-blue",
    PURPLE: "purple",
    PURPLE_LIGHT: "purple-light",
    PURPLE_DARK: "purple-dark",
    PINK: "pink",
    PINK_LIGHT: "pink-light",
    PINK_DARK: "pink-dark",
    PIPPER: "pipper",
    PIPPER_LIGHT: "pipper-light",
    PIPPER_DARK: "pipper-dark",
    CORAL: "coral",
    DARK_GREEN: "dark-green",
    MEDIUM_GREEN: "medium-green",
    LIGHT_GREEN: "light-green",
    DARK_ORANGE: "dark-orange",
    MEDIUM_ORANGE: "medium-orange",
    LIGHT_ORANGE: "light-orange",
    LIGHT_BLUE: "light-blue",
    MEDIUM_BLUE: "medium-blue",
    DARK_BLUE: "dark-blue",
    DARK_PURPLE: "dark-purple",
    MEDIUM_PURPLE: "medium-purple",
    LIGHT_PURPLE: "light-purple",
    RED: "red",
    DARK_YELLOW: "dark-yellow",
    MEDIUM_YELLOW: "medium-yellow",
    LIGHT_YELLOW: "light-yellow",
    ORCHID_DARK: "orchid-dark",
};
exports.PRICE_DECORATION = {
    LINE_THROUGH: "linethrough",
    UNDERLINE: "underline",
    NONE: "none",
};
exports.PRICE_OPACITY = {
    OP_1: "op-1",
    OP_0_5: "op-0-5",
    OP_0_25: "op-0-25",
};
exports.PRICE_FONT_TYPE = {
    REGULAR: "regular",
    LIGHT: "light",
    THIN: "thin",
    BOLD: "bold",
    HAND: "hand",
};
exports.PRICE_DISPLAY = {
    INLINE: "inline",
    BLOCK: "block",
};
//# sourceMappingURL=enums.js.map